import { openDB } from 'idb';

import { RecurringDeposit } from '../models/recurring-deposit';

const dbPromise = openDB('recurringDepositDB', 1, {
  upgrade(db) {
    db.createObjectStore('recurringDeposits', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveRecurringDeposit = async (data: RecurringDeposit): Promise<void> => {
  const db = await dbPromise;
  await db.add('recurringDeposits', data);
};

export const fetchRecurringDeposits = async (): Promise<RecurringDeposit[]> => {
  const db = await dbPromise;
  return await db.getAll('recurringDeposits');
};

export const updateRecurringDeposit = async (id: number, updatedData: Omit<RecurringDeposit, 'id'>): Promise<void> => {
  const db = await dbPromise;

  console.log(`Updating deposit with ID: ${id}`);
  console.log('Updated data:', { id, ...updatedData });

  await db.put('recurringDeposits', { id, ...updatedData });
};


export const deleteRecurringDeposit = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('recurringDeposits', id);
};
